goog.provide('el8.ptdata.model.med.thread');

goog.require('el8.model.identify');
goog.require('el8.model.base');
goog.require('el8.template.ptdata.model.medOrderThread');


el8.ptdata.model.med.thread = function(spec) { this.populate(spec); };
el8.ptdata.model.med.thread.inheritsFrom(el8_Entity);
el8.ptdata.model.med.thread.prototype.populate = function(spec) {
    spec = spec || {};
    if (spec.latest_order) {  // assume always comes down with server
        if (spec.latest_order.model_class === 'MedOrder') {
            el8.ptdata.medOrders.create(spec.latest_order, true);
        } else if (spec.latest_order.model_class === 'DiscontinueMedOrder') {
            el8.ptdata.dcMedOrders.create(spec.latest_order, true);
        }
    }
    if (spec.all_orders) {
        var allOrderIds = [];
        for (var i=0; i<spec.all_orders.length; i++) {
            var currOrder = spec.all_orders[i];
            allOrderIds.push(currOrder.id);
            if (currOrder.model_class === 'MedOrder') {
                el8.ptdata.medOrders.create(currOrder, true);
            } else if (currOrder.model_class === 'DiscontinueMedOrder') {
                el8.ptdata.dcMedOrders.create(currOrder, true);
            }
        }
        spec.all_order_ids = allOrderIds;
    }
    el8_Entity.prototype.populate.call(this, spec);
};
el8.ptdata.model.med.thread.makeDeleteable();
el8.ptdata.model.med.thread.addDateTime("documentDate");
el8.ptdata.model.med.thread.addBoolean("active");
el8.ptdata.model.med.thread.addBoolean("permanent");
el8.ptdata.model.med.thread.addBoolean("controlled");
el8.ptdata.model.med.thread.addBoolean("canceled");
el8.ptdata.model.med.thread.addDate("startDate");
el8.ptdata.model.med.thread.addDate("discontinueDate");
el8.ptdata.model.med.thread.addBoolean("rxDownload", false, false);

el8.ptdata.model.med.thread.addIntProperty("latestMedOrderId");
el8.ptdata.model.med.thread.addIntProperty("latestDcMedOrderId");

/**
 * OPTIONAL property contains both med orders and dc med orders
 * - only present when thread has been downloaded for meds hx
 * - expected to be sorted in reverse chronological order by effectiveDate
 *
 * TODO Make sure these get updated properly when creating new orders, etc.
 */
el8.ptdata.model.med.thread.addProperty("allOrderIds", false, []);

/**
 * Helpers around fetching associated orders
 */
el8.ptdata.model.med.thread.prototype.getAllOrders = function() {
    var result = this.getAllOrderIds().map(function(id) {
        if (el8.model.idToModelClass(id) === 'MedOrder') {
            return el8.ptdata.medOrders.getById(id, false);
        } else if (el8.model.idToModelClass(id) === 'DiscontinueMedOrder') {
            return el8.ptdata.dcMedOrders.getById(id, false);
        }
        return null;
    });
    return result;
};
el8.ptdata.model.med.thread.prototype.getAssociatedDcOrder = function(medOrderId) {
    var allOrders = this.getAllOrders();
    for (var i=0; i<allOrders.length; i++) {
        if (allOrders[i].is('DiscontinueMedOrder')) {
            if (allOrders[i].getMedOrderId() === medOrderId) {
                return allOrders[i];
            }
        }
    }
    return null;
};

/**
 * Methods around manipulating owned orders
 */
el8.ptdata.model.med.thread.prototype.getLatestOrderId = function() {
    return this.getLatestDcMedOrderId() || this.getLatestMedOrderId();
};
el8.ptdata.model.med.thread.prototype.getLatestOrder = function() {
    return el8.ptdata.fetch({
        'id': this.getLatestOrderId(),
        'model_class': el8.model.idToModelClass(this.getLatestOrderId())
    });
};
el8.ptdata.model.med.thread.prototype.getLatestMedOrder = function() {
    if (!this.getLatestMedOrderId()) { return null; }
    return el8.ptdata.fetch({
        'id': this.getLatestMedOrderId(),
        'model_class': el8.model.idToModelClass(this.getLatestMedOrderId())
    });
};
el8.ptdata.model.med.thread.prototype.getLatestActivityDate = function() {
    var latestMedOrder = this.getLatestOrder();
    if (latestMedOrder) {
        return latestMedOrder.getStartDate();
    }
    return this.getStartDate();
};

/**
 * Helpers to get other basic information from thread
 */
el8.ptdata.model.med.thread.prototype.asSoyMap = function() {

    var mapped = el8_Entity.prototype.asSoyMap.call(this);

    delete mapped['latestMedOrderId'];
    delete mapped['latestDcMedOrderId'];
    delete mapped['allOrderIds'];

    mapped['latestOrder'] = this.getLatestOrder().asSoyMap();
    return mapped;
};
